import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
//import store from "./store/store";
import applyMaintenanceGuard from './maintenanceGuard';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "/authentication/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        // Application
        {
          name: "Login",
          path: "/authentication/login",
          component: () => import("@/views/authentication/Login"),
          meta: { allowDuringMaintenance: true }
          //meta: { guest: true },
        },

        {
          name: "Dashboard",
          path: "/",
          redirect: "/authentication/login",
          component: () => import("@/layouts/full-layout/Layout"),
          children:
            [
              {
                name: "Carriers",
                path: "carrier",
                component: () => import("@/views/apps/pages/carrier"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rate Management",
                path: "rates_management",
                component: () => import("@/views/apps/pages/rates_management"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customers",
                path: "customers",
                component: () => import("@/views/apps/pages/customers"),
                meta: { requiresAuth: true },
              },
              {
                name: "Business Profile",
                path: "businessprofile",
                component: () => import("@/views/apps/pages/businessprofile"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites",
                path: "sites",
                component: () => import("@/views/apps/pages/sites"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Detail",
                path: "/sitesdetail/:id",
                component: () => import("@/views/apps/pages/sitesdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Sites Edit",
                path: "/sitesedit/:id",
                component: () => import("@/views/apps/pages/sitesedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Contracts & Origins",
                path: "carrier_contracts_origins",
                component: () => import("@/views/apps/pages/carrier_contracts_origins"),
                meta: { requiresAuth: true },
              },
              {
                name: "Search",
                path: "search",
                component: () => import("@/views/apps/pages/search"),
                meta: { requiresAuth: true },
              },
              {
                name: "Dashboard",
                path: "dashboard",
                component: () => import("@/views/apps/pages/dashboard"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Detail",
                path: "/carrierdetail/:id",
                component: () => import("@/views/apps/pages/carrierdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Master Equivalences",
                path: "/master_equivalences",
                component: () => import("@/views/apps/pages/master_equivalences"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Specific Charges",
                path: "/carriers/carrier_specific_charges",
                component: () => import("@/views/apps/pages/carriers/carrier_specific_charges"),
                meta: { requiresAuth: true },
              },
              {
                name: "Purolator Tax Rates",
                path: "/purolator_tax_rates",
                component: () => import("@/views/apps/pages/purolator_tax_rates"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Service Equivalency",
                path: "carriers/carrier_service_equivalency",
                component: () => import("@/views/apps/pages/carriers/carrier_service_equivalency"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Surcharge Equivalency",
                path: "carriers/carrier_surcharge_equivalency",
                component: () => import("@/views/apps/pages/carriers/carrier_surcharge_equivalency"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Reset Password",
                path: "/customer/password/reset_token/:password_reset_token",
                component: () => import("@/views/apps/pages/customer_reset_password"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Detail",
                path: "/customerdetail/:id",
                component: () => import("@/views/apps/pages/customerdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Edit",
                path: "/customeredit/:id",
                component: () => import("@/views/apps/pages/customeredit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Management Detail",
                path: "/rates_managementdetail/:id",
                component: () => import("@/views/apps/pages/rates_managementdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Management Edit",
                path: "/rates_managementedit/:id",
                component: () => import("@/views/apps/pages/rates_managementedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Tariffs",
                path: "carriers/carrier_tariffs",
                component: () => import("@/views/apps/pages/carriers/carrier_tariffs"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Tariff Detail",
                path: "carriers/carrier_tariffdetail/:id",
                component: () => import("@/views/apps/pages/carriers/carrier_tariffdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Bills",
                path: "carriers/invoices",
                component: () => import("@/views/apps/pages/carriers/invoices"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Bills Detail",
                path: "carriers/carrierbillsdetail/:id",
                component: () => import("@/views/apps/pages/carriers/carrierbillsdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Queue",
                path: "queue",
                component: () => import("@/views/apps/pages/queue"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users",
                path: "users",
                component: () => import("@/views/apps/pages/users"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Detail",
                path: "/usersdetail/:id",
                component: () => import("@/views/apps/pages/usersdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Users Edit",
                path: "/usersedit/:id",
                component: () => import("@/views/apps/pages/usersedit"),
                meta: { requiresAuth: true },
              },
              {
                name: "Invoice",
                path: "invoice",
                component: () => import("@/views/apps/pages/invoice"),
                meta: { requiresAuth: true },
              },
              {
                name: "2Ship API",
                path: "2ship_api",
                component: () => import("@/views/apps/pages/2ship_api"),
                meta: { requiresAuth: true },
              },
              {
                name: "FedEx API",
                path: "fedex_api",
                component: () => import("@/views/apps/pages/fedex_api"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal",
                path: "analysis/proposal/:id",
                component: () => import("@/views/apps/pages/analysis/proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal ID",
                path: "analysis/proposal ",
                component: () => import("@/views/apps/pages/analysis/proposal "),
                meta: { requiresAuth: true },
              },
              {
                name: "Ratecard Proposal",
                path: "analysis/ratecard_proposal",
                component: () => import("@/views/apps/pages/analysis/ratecard_proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Ratecard Report",
                path: "analysis/ratecard_report",
                component: () => import("@/views/apps/pages/analysis/ratecard_report"),
                meta: { requiresAuth: true },
              },
              {
                name: "Rates Report",
                path: "analysis/ratesreport/:id",
                component: () => import("@/views/apps/pages/analysis/ratesreport"),
                meta: { requiresAuth: true },
              },
              {
                name: "Analyze Invoice",
                path: "analysis/analyze_invoice/:id",
                component: () => import("@/views/apps/pages/analysis/analyze_invoice"),
                meta: { requiresAuth: true },
              },
              {
                name: "Ship Customer Location",
                path: "analysis/ship_customer_location",
                component: () => import("@/views/apps/pages/analysis/ship_customer_location"),
                meta: { requiresAuth: true },
              },
              {
                name: "Switching Analysis",
                path: "analysis/switching_analysis",
                component: () => import("@/views/apps/pages/analysis/switching_analysis"),
                meta: { requiresAuth: true },
              },
              {
                name: "Proposal",
                path: "analysis/proposals/:id",
                component: () => import("@/views/apps/pages/analysis/proposals"),
                meta: { requiresAuth: true },
              },
              {
                name: "Client Proposal Materials",
                path: "analysis/client_proposal_materials",
                component: () => import("@/views/apps/pages/analysis/client_proposal_materials"),
                meta: { requiresAuth: true },
              },
              {
                name: "Integrations",
                path: "analysis/integrations",
                component: () => import("@/views/apps/pages/analysis/integrations"),
                meta: { requiresAuth: true },
              },
              {
                name: "GeneratedProposal",
                path: "analysis/generated-proposal",
                component: () => import("@/views/apps/pages/analysis/generated-proposal"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Work flow",
                path: "billing/billingworkflow",
                component: () => import("@/views/apps/pages/billing/billingworkflow"),
                meta: { requiresAuth: true },
              },
              {
                name: "Batch Report Detail",
                path: "billing/batchreportdetail/:id",
                component: () => import("@/views/apps/pages/billing/batchreportdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Work flow Detail",
                path: "billing/billingworkflowdetail/:id",
                component: () => import("@/views/apps/pages/billing/billingworkflowdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Batch Reports",
                path: "billing/batchreports",
                component: () => import("@/views/apps/pages/billing/batchreports"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer Bills",
                path: "billing/customerbills",
                component: () => import("@/views/apps/pages/billing/customerbills"),
                meta: { requiresAuth: true },
              },
              {
                name: "SimpleCustomerBilling",
                path: "billing/simplecustomerbilling",
                component: () => import("@/views/apps/pages/billing/simplecustomerbilling"),
                meta: { requiresAuth: true },
              },
              {
                name: "ComplexCustomerBilling",
                path: "billing/complexcustomerbilling",
                component: () => import("@/views/apps/pages/billing/complexcustomerbilling"),
                meta: { requiresAuth: true },
              },
              {
                name: "Complex Billing Detail",
                path: "billing/complexbillingdetail/:id",
                component: () => import("@/views/apps/pages/billing/complexbillingdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing",
                path: "billing",
                component: () => import("@/views/apps/pages/billing"),
                meta: { requiresAuth: true },
              },
              {
                name: "Billing Detail",
                path: "billingdetail/:id",
                component: () => import("@/views/apps/pages/billingdetail"),
                meta: { requiresAuth: true },
              },
              {
                name: "Add Customers to FedEx EDI",
                path: "addcustomerfedex",
                component: () => import("@/views/apps/pages/tools/addcustomerfedex"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer",
                path: "customer",
                component: () => import("@/views/apps/pages/customer"),
                meta: { requiresAuth: true },
              },
              {
                name: "Event Log",
                path: "event_log",
                component: () => import("@/views/apps/pages/user_log"),
                meta: { requiresAuth: true },

              },
              {
                name: "Add File",
                path: "add_file",
                component: () => import("@/views/apps/pages/add_file"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Login",
                path: "carrier_login",
                component: () => import("@/views/apps/pages/carrier_login"),
                meta: { requiresAuth: true },
              },
              {
                name: "Settings",
                path: "settings",
                component: () => import("@/views/apps/pages/settings"),
                meta: { requiresAuth: true },
              },
              {
                name: "Packages",
                path: "packages",
                component: () => import("@/views/apps/pages/packages"),
                meta: { requiresAuth: true },
              },
              {
                name: "Your Profile",
                path: "your_profile",
                component: () => import("@/views/apps/pages/your_profile"),
                meta: { requiresAuth: true },
              },
              {
                name: "Test",
                path: "test",
                component: () => import("@/views/apps/pages/test"),
                meta: { requiresAuth: true },
              },
              {
                name: "Duplicate Finder",
                path: "duplicate_finder",
                component: () => import("@/views/apps/pages/duplicate_finder"),
                meta: { requiresAuth: true },
              },
              {
                name: "Maintenance Page",
                path: "maintenance_page",
                component: () => import("@/views/apps/pages/maintenance_page"),
                meta: { requiresAuth: true },
              },
            ],

        },
        {
          name: "Maintenance",
          path: "maintenance",
          component: () => import("@/views/apps/pages/maintenance"),
          // meta: { requiresAuth: true },
          // meta: { allowDuringMaintenance: true } 
          meta: { requiresAuth: true, allowDuringMaintenance: true }
        },
      ],
    },
    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Forget Password",
          path: "forgetpswd",
          component: () => import("@/views/authentication/forgetpswd"),
        },
        {
          name: "Reset Password",
          path: "resetpswd/:id",
          component: () => import("@/views/authentication/resetpswd"),
        },
        {
          name: "Test Login",
          path: "testlogin",
          component: () => import("@/views/authentication/testlogin"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Test Login",
          path: "teststore",
          component: () => import("@/views/authentication/teststore"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Logout",
          path: "logout",
          component: () => import("@/views/authentication/Logout"),
          meta: { requiresAuth: true },
        },
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

applyMaintenanceGuard(router);

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
    console.log(isAuthenticated);
    console.log("test auth------->");

    if (isAuthenticated) {
      next();
      return;
    }
    next("/authentication/login");
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/apps/pages/dashboard");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default router;
